const REPO_KEY = 'ark-repo'

export const loadRepo = () => {
  try {
    const stored = localStorage.getItem(REPO_KEY)
    if (stored) return JSON.parse(stored)
  } catch (err) { console.error('Error loading repo:', err) }
  return {}
}

export const saveEntry = (entry) => {
  try {
    const repo = loadRepo()
    repo[entry.id] = entry
    localStorage.setItem(REPO_KEY, JSON.stringify(repo))
  } catch (err) { console.error('Error saving entry:', err) }
}

export const deleteEntry = (id) => {
  try {
    const repo = loadRepo()
    delete repo[id]
    localStorage.setItem(REPO_KEY, JSON.stringify(repo))
  } catch (err) { console.error('Error deleting entry:', err) }
}

export const updateEntryStatus = (id, status) => {
  try {
    const repo = loadRepo()
    if (repo[id]) {
      repo[id] = { ...repo[id], status, updated: new Date().toISOString() }
      localStorage.setItem(REPO_KEY, JSON.stringify(repo))
    }
  } catch (err) { console.error('Error updating status:', err) }
}
